import React from 'react';
import { Loader2, CloudOff, RefreshCw, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/Button';

interface OfflineLoadingStateProps {
  isLoading: boolean;
  isOnline: boolean;
  error?: string | null;
  onRetry?: () => void;
  loadingMessage?: string;
  offlineMessage?: string;
  className?: string;
}

export const OfflineLoadingState: React.FC<OfflineLoadingStateProps> = ({
  isLoading,
  isOnline,
  error,
  onRetry,
  loadingMessage = "Φόρτωση δεδομένων...",
  offlineMessage = "Χρήση δεδομένων από την τοπική αποθήκευση",
  className = ""
}) => {
  if (isLoading) {
    return (
      <div className={`flex items-center justify-center p-8 ${className}`}>
        <div className="text-center">
          <Loader2 className="h-8 w-8 text-blue-500 animate-spin mx-auto mb-3" />
          <p className="text-gray-600 text-sm">{loadingMessage}</p>
          {!isOnline && (
            <div className="mt-2 flex items-center justify-center gap-2 text-amber-600">
              <CloudOff className="w-4 h-4" />
              <span className="text-xs">{offlineMessage}</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`flex items-center justify-center p-8 ${className}`}>
        <div className="text-center max-w-md">
          <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {isOnline ? 'Σφάλμα φόρτωσης' : 'Πρόβλημα offline λειτουργίας'}
          </h3>
          <p className="text-gray-600 mb-4 text-sm">{error}</p>
          
          {!isOnline && (
            <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
              <div className="flex items-center gap-2 text-amber-700">
                <CloudOff className="w-4 h-4" />
                <span className="text-sm">
                  Δεν υπάρχει σύνδεση στο διαδίκτυο
                </span>
              </div>
              <p className="text-xs text-amber-600 mt-1">
                Τα δεδομένα θα φορτωθούν από την τοπική αποθήκευση
              </p>
            </div>
          )}

          {onRetry && (
            <Button 
              onClick={onRetry}
              variant="outline"
              className="touch-target"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Δοκιμή ξανά
            </Button>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default OfflineLoadingState;
